import { render, staticRenderFns } from "./IntegrationSettingsModal.vue?vue&type=template&id=a98e2e60&scoped=true"
import script from "./IntegrationSettingsModal.vue?vue&type=script&lang=js"
export * from "./IntegrationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettingsModal.vue?vue&type=style&index=0&id=a98e2e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e2e60",
  null
  
)

export default component.exports